import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f7054622"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-label"];
const _hoisted_2 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_IconSwitcher = _resolveComponent("IconSwitcher");
    const _component_Tooltip = _resolveComponent("Tooltip");
    const _component_IconBar = _resolveComponent("IconBar");
    const _component_ContextMenu = _resolveComponent("ContextMenu");
    return (_openBlock(), _createBlock(_component_ContextMenu, {
        options: _ctx.contextMenuItems,
        onOnMenuItemClick: _ctx.onContextMenuItemClick,
        onOnMenuItemRightClick: _ctx.onContextMenuItemRightClick
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", {
                class: _normalizeClass('title' + _ctx.selectedclass(_ctx.treeDatumID)),
                style: _normalizeStyle(_ctx.indentStyle),
                "data-label": _ctx.treeDatum.title,
                onClick: _cache[7] || (_cache[7] =
                    //@ts-ignore
                    (...args) => (_ctx.titleBarClick && _ctx.titleBarClick(...args)))
            }, [
                (_ctx.treeDatum.nodes)
                    ? (_openBlock(), _createBlock(_component_IconSwitcher, {
                        key: 0,
                        class: "title-element clickable expand-icon",
                        useFirst: _ctx.treeDatum.treeExpanded,
                        iconID1: ['fa', 'angle-down'],
                        iconID2: ['fa', 'angle-right'],
                        width: 15,
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.toggleExpand(_ctx.treeDatumID)))
                    }, null, 8, ["useFirst"]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        style: _normalizeStyle(_ctx.flexFixedWidth(7))
                    }, null, 4)),
                _createVNode(_component_Tooltip, { tip: _ctx.selInstructions }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            class: "title-text clickable",
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.titleClick(_ctx.treeDatumID))),
                            style: _normalizeStyle(_ctx.treeDatum.visible ? '' : 'color: lightgray;')
                        }, [
                            _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
                            (_ctx.treeDatum.nodes)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.descendentCounts(_ctx.treeDatum)), 1))
                                : _createCommentVNode("", true)
                        ], 4)
                    ]),
                    _: 1
                }, 8, ["tip"]),
                _createVNode(_component_IconBar, {
                    width: 24 * Object.keys(_ctx.iconsToDisplay).length,
                    extraClasses: "me-2 selected",
                    style: { "margin-right": "8px" }
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_IconSwitcher, {
                            class: "title-element clickable",
                            useFirst: _ctx.treeDatum.visible,
                            iconID1: _ctx.visibleIconToUse,
                            iconID2: _ctx.visibleIconToUse,
                            icon2Style: { color: 'lightgray' },
                            width: 22,
                            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.toggleVisible(_ctx.treeDatumID))),
                            title: "Visible"
                        }, null, 8, ["useFirst", "iconID1", "iconID2"]),
                        (_ctx.iconsToDisplay.focused)
                            ? (_openBlock(), _createBlock(_component_IconSwitcher, {
                                key: 0,
                                class: "title-element clickable",
                                useFirst: _ctx.treeDatum.focused,
                                iconID1: ['fa', 'arrows-to-eye'],
                                iconID2: ['fa', 'arrows-to-eye'],
                                icon2Style: { color: 'lightgray' },
                                width: 22,
                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.toggleFocused(_ctx.treeDatumID))),
                                title: "Focus"
                            }, null, 8, ["useFirst"]))
                            : _createCommentVNode("", true),
                        (_ctx.iconsToDisplay.delete)
                            ? (_openBlock(), _createBlock(_component_IconSwitcher, {
                                key: 1,
                                class: "title-element clickable delete",
                                useFirst: true,
                                iconID1: ['far', 'rectangle-xmark'],
                                iconID2: ['far', 'rectangle-xmark'],
                                width: 22,
                                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.deleteMol(_ctx.treeDatumID))),
                                title: "Delete"
                            }))
                            : _createCommentVNode("", true),
                        (_ctx.iconsToDisplay.cloneExtract)
                            ? (_openBlock(), _createBlock(_component_IconSwitcher, {
                                key: 2,
                                class: "title-element clickable cloneextract",
                                useFirst: true,
                                iconID1: ['far', 'clone'],
                                iconID2: ['far', 'clone'],
                                width: 22,
                                onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.cloneMol(_ctx.treeDatumID))),
                                title: "Clone"
                            }))
                            : _createCommentVNode("", true),
                        (_ctx.iconsToDisplay.rename)
                            ? (_openBlock(), _createBlock(_component_IconSwitcher, {
                                key: 3,
                                class: "title-element clickable rename",
                                useFirst: true,
                                iconID1: ['fa', 'pencil'],
                                iconID2: ['fa', 'pencil'],
                                width: 22,
                                onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.renameMol(_ctx.treeDatumID))),
                                title: "Rename"
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["width"])
            ], 14, _hoisted_1)
        ]),
        _: 1
    }, 8, ["options", "onOnMenuItemClick", "onOnMenuItemRightClick"]));
}
